export default "__VITE_ASSET__ChTjsmda__"